import type { IconProps } from './types/types';

const ComboChartIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    {/* Bar 부분 */}
    <rect x="2" y="8" width="2" height="6" />
    <rect x="5" y="6" width="2" height="8" />
    <rect x="8" y="10" width="2" height="4" />

    {/* Line 부분 */}
    <path
      d="M2 4 L5 2 L8 3 L11 1 L14 2"
      stroke="currentColor"
      strokeWidth="1.5"
      fill="none"
    />
    <circle cx="2" cy="4" r="1" />
    <circle cx="5" cy="2" r="1" />
    <circle cx="8" cy="3" r="1" />
    <circle cx="11" cy="1" r="1" />
    <circle cx="14" cy="2" r="1" />
  </svg>
);

export default ComboChartIcon;
